import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { fontSizes, fontWeights } from '../../helpers/tileHelper';
import { Icon } from '../Icon/Icon';
import ChevronUp from '../../../assets/icons/svg/ChevronUp';
import ChevronDown from '../../../assets/icons/svg/ChevronDown';

export interface ParagraphProps {
  children: string | ReactNode;
  moreChildren?: string;
  size?: keyof typeof fontSizes;
  weight?: keyof typeof fontWeights;
  italic?: boolean;
  truncate?: number;
  className?: string;
  expandable?: boolean;
}

export const Paragraph: React.FC<ParagraphProps> = ({
  children,
  moreChildren,
  size = 12,
  weight = 'medium',
  italic = false,
  truncate = 2,
  className = '',
  expandable
}) => {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const heightRef = useRef<HTMLParagraphElement>(null);
  const toggleEnable = truncate > 0 && expandable;
  const showReadMoreButton = () => toggleEnable && heightRef.current && setHidden(heightRef.current.offsetHeight === heightRef.current.scrollHeight);

  useEffect(() => {
    showReadMoreButton();
    window.addEventListener('resize', showReadMoreButton);
    return () => window.removeEventListener('resize', showReadMoreButton);
  }, []);

  return (
    <>
      <p
        ref={heightRef}
        className={`m-0 lining-nums break-words ${fontSizes[size]} ${fontWeights[weight]} ${italic ? 'italic' : ''} ${className} line-clamp-2`}
        style={{ WebkitLineClamp: open ? 50 : truncate }}
      >
        {children}{moreChildren && <span className={`${fontSizes[12]} ${fontWeights['medium']}`}>{` ${moreChildren}`}</span>}
      </p>
      {toggleEnable && <a onClick={(e) => { setOpen(!open); e.preventDefault(); }} href='#' className='text-14 font-bold text-neutrals-grey-950 focus-within:outline-none' hidden={hidden}>
        {`${open ? 'Vis mindre' : 'Vis mere'}`}<Icon icon={open ? <ChevronUp /> : <ChevronDown />} size='large' className='align-bottom' />
      </a>
      }
    </>
  );
};
